import React, { Component } from 'react';
import Formulario from './DistribuidorForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Distribuidor extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo, listarCentroCosto, paisList } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
        paisList();
        listarCentroCosto();
    }
    
    render(){
        const { registroDistribuidor, modificarDistribuidor, pais,
            loader, modulo, listaCentros, lectura, listarCuentasContables } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    registroDistribuidor = {registroDistribuidor}
                    modificarDistribuidor = {modificarDistribuidor}
                    lectura = {lectura}
                    obtenerPaises = { pais }
                    crear = {crear}
                    modulo = {modulo}
                    listaCentros = {listaCentros}
                    listarCuentasContables = {listarCuentasContables}
                />
            </LoadMask>
        );
    }
}


export default Distribuidor;